import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 1,
    },
  },
})

// Expose query client on window for e2e tests and debugging
if (import.meta.env.DEV || import.meta.env.MODE === 'test') {
  ;(window as any).__QUERY_CLIENT__ = queryClient
}
